// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__eIwre","tab":"Tabs_tab__qJI5b","tabActive":"Tabs_tabActive__37tva"};